export default __webpack_public_path__ + "static/property001-8cf7ecd87bb82dea59d735193bd73720.png";